/**
 * Seed specs for the Design panel's first-run state.
 *
 * Currently empty: design specs are project-scoped and live in the
 * GboxDocument (`design` field) once the schema change lands. Fresh
 * sandboxes ship with no specs rather than a global seed that would
 * bleed into every project.
 */

import type { DesignSpec } from './types';

export const DEFAULT_SEED_SPECS: DesignSpec[] = [];
